import classlist from 'utils/classlist';
import { BankCardAuthStatus, BankCardItemTypes } from '../type';
import './style.scss';

const bankCardAuthStatusMap = {
    [BankCardAuthStatus.New]: __('bankcards:未认证'),
    [BankCardAuthStatus.Insufficient]: __('bankcards:补充资料'),
    [BankCardAuthStatus.Unaudited]: __('bankcards:审核中'),
    [BankCardAuthStatus.Audited]: __('bankcards:认证通过'),
    [BankCardAuthStatus.AuditFail]: __('bankcards:认证失败')
};

const BankCardAuthStatusTag: React.FC<{
    status: BankCardAuthStatus;
    needAuthenticated?: BankCardItemTypes['needAuthenticated'];
    hidden?: boolean;
}> = ({ status, needAuthenticated, hidden }) => {
    const bankCardAuthStatus = bankCardAuthStatusMap[status];

    if (hidden || !bankCardAuthStatus || !(status !== BankCardAuthStatus.New || needAuthenticated)) {
        return null;
    }

    return (
        <span className={classlist('bank-card-auth-tag', `bank-card-auth-tag-${status}`)}>{bankCardAuthStatus}</span>
    );
};

export { BankCardAuthStatusTag };
